import React, { useState } from 'react';
import AuthLayout from '../Layouts/authLayout';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { withStyles } from '@material-ui/core/styles';
import { Link, useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { validateIsNotempty, validatePassword, querystring } from '../../utils';
import { resetPassword } from '../../actions/userActions';
import { toast } from 'react-toastify';
import LoadingView from '../Loader/LoadingView';

const styles = {
	logo : {
		width  : '100%',
		height : 'auto'
	},
	'btnColor' : {
		background
		: '#0F9710',
		color
		: 'white',
		fontWeight
		: 'bold'
	},
	'fullWidth' : {
		width
		: '100%'
	}
};

const ResetPasswordPage = ({ classes }) =>
{
	const [ loading, setLoading ] = useState(false);

	const history = useHistory();

	const token = querystring('token');

	const handleSubmit = (event) =>
	{
		event.preventDefault();
		const data = new FormData(event.currentTarget);

		const psw = data.get('newpassword');

		const cnfpsw = data.get('cnfpassword');

		if (!validateIsNotempty(psw))
		{
			toast.error('Please enter the password');
		}
		else if (!validatePassword(psw))
		{
			toast.error('Password should contain one Capital latest, one Numaric Value and one Special charecter. Length should be minimum 8 charecters');
		}
		else if (psw !== cnfpsw)
		{
			toast.error('Password and Confirm Password should be same');
		}
		else if (!loading)
		{
			setLoading(true);
			const obj = {
				token : token,

				password : psw
			};

			resetPassword(obj).then(() =>
			{
				toast.success('Password reset successfully');
				history.push('/');
			})
				.catch(() =>
				{
					setLoading(false);
					toast.error('Internal Server Error, Please try again');
				});
		}
	};

	return (
		<Container component='main' maxWidth='xs' className={classes.root}>
			<CssBaseline />
			{loading && <LoadingView />}
			<Box
				sx={{
					display       : 'flex',
					flexDirection : 'column'
				}}
			>
				<span className='subHeadingSM'><b>Reset Password</b></span>
				<Box component='form' onSubmit={handleSubmit} noValidate sx={{ mt: 1 }} className={classes.fullWidth}>
					<TextField
						variant='outlined'
						margin='normal'
						required
						fullWidth
						id='newpassword'
						placeholder='New Password'
						name='newpassword'
						autoFocus
						InputLabelProps={{
							style : { color: '#fff' }
						}}
						className='inputField'
						type='password'
					/>
					<TextField
						variant='outlined'
						margin='normal'
						required
						fullWidth
						id='cnfpassword'
						placeholder='Confirm Password'
						name='cnfpassword'
						autoFocus
						InputLabelProps={{
							style : { color: '#fff' }
						}}
						className='inputField'
						type='password'
					/>
					<div className='flexAutoCol mrgnVSM'>
						<Button
							type='submit'
							fullWidth
							variant='contained'
							className={classes.btnColor}
						>
							Submit
						</Button>
					</div>
					<Grid container>
						<Grid item xs>
							<Link to='/' variant='body2' className='txtColorBlackL txtDecorationNone'>
								<b>Login</b>
							</Link>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</Container>
	);
};

export default AuthLayout(withStyles(styles)(ResetPasswordPage));
